import { render, staticRenderFns } from "./Ruban.vue?vue&type=template&id=0aeb1fef&"
import script from "./Ruban.vue?vue&type=script&lang=js&"
export * from "./Ruban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports